<template>
  <v-container>
    <h1 class="text-center">Giveaway mit Chat Command</h1>
    <v-toolbar flat>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-toolbar>

    <!-- Desktop: Data Table -->
    <v-data-table
      v-if="!$vuetify.breakpoint.smAndDown"
      :search="search"
      :headers="headers"
      :items="giveaways"
      sort-by="calories"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-dialog v-model="dialog" max-width="80vw">
          <v-card>
            <v-card-text>
              <v-container>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.title"
                        label="Titel"
                        :rules="[v => !!v || 'Titel is required']"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-checkbox v-model="editedItem.confirm_buyin" label="Kauf bestätigung" />
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="save" :loading="saving">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5">Sicher dieses Giveaway löschen?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete">Nein!</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">Ja!</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog class="justify-content=center" v-model="dialogWinner" max-width="500px">
          <v-card class="text-center">
            <v-card-title class="text-h5">
              Der Gewinner dieses Giveaways ist:<br>{{ winner }}
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="pickWinner(safeWinnerItem)">Reroll!</v-btn>
              <v-btn color="blue darken-1" text @click="closeGiveawayWinnerDialog">Verstanden!</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template v-slot:[`item.confirm_buyin`]="{ item }">
        <div>{{ item.confirm_buyin === 1 ? 'Ja' : 'Nein' }}</div>
      </template>
      <template v-slot:[`item.started`]="{ item }">
        <div v-if="item.started">{{ new Date(item.started * 1000).toLocaleString('de-De') }}</div>
        <i v-else>-</i>
      </template>
      <template v-slot:[`item.stopped`]="{ item }">
        <div v-if="item.stopped">{{ new Date(item.stopped * 1000).toLocaleString('de-De') }}</div>
        <i v-else>-</i>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top color="success">
          <template v-slot:activator="{ on, attrs }">
            <v-icon small class="mr-2" @click="editItem(item)" v-bind="attrs" v-on="on">
              mdi-pencil
            </v-icon>
          </template>
          <span>Editieren!</span>
        </v-tooltip>
        <v-tooltip top color="success">
          <template v-slot:activator="{ on, attrs }">
            <v-icon small class="mr-2" @click="copyItem(item)" v-bind="attrs" v-on="on">
              mdi-content-copy
            </v-icon>
          </template>
          <span>Kopieren!</span>
        </v-tooltip>
        <v-tooltip top color="error">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              :disabled="item.started ==! null && item.stopped === null"
              @click="deleteItem(item)"
              v-bind="attrs"
              v-on="on"
            >
              mdi-delete
            </v-icon>
          </template>
          <span>Löschen!</span>
        </v-tooltip>
        <v-tooltip top color="success">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              @click="startItem(item)"
              :disabled="giveaways.filter(
                (item) => item.started !== null && item.stopped === null
                ).length > 0"
              v-bind="attrs"
              v-on="on"
            >
              mdi-play
            </v-icon>
          </template>
          <span>Starten!</span>
        </v-tooltip>
        <v-tooltip top color="error">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              @click="stopItem(item)"
              :disabled="item.started === null || item.stopped !== null"
              v-bind="attrs"
              v-on="on"
            >
              mdi-stop
            </v-icon>
          </template>
          <span>Stoppen!</span>
        </v-tooltip>
        <v-tooltip top color="warning">
          <template v-slot:activator="{ on, attrs }">
            <v-btn :to="`/giveawayNoPointsEntrant/${item.id}`" target="_blank" icon :disabled="item.started === null">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on">mdi-link</v-icon>
            </v-btn>
          </template>
          <span>Teilnehmerliste!</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <!-- Mobile: Card List -->
    <template v-else>
      <v-card
        v-for="item in mobileItems"
        :key="item.id"
        class="mb-3"
        outlined
      >
        <v-card-title class="d-flex justify-space-between align-center py-2">
          <span>{{ item.title }}</span>
          <v-chip
            x-small
            :color="item.started !== null && item.stopped === null ? 'success' : item.stopped !== null ? 'grey' : 'default'"
          >
            {{ item.started !== null && item.stopped === null ? 'Läuft' : item.stopped !== null ? 'Beendet' : 'Neu' }}
          </v-chip>
        </v-card-title>
        <v-card-subtitle class="pb-0">
          <v-chip x-small class="mr-1">Bestätigung: {{ item.confirm_buyin === 1 ? 'Ja' : 'Nein' }}</v-chip>
        </v-card-subtitle>
        <v-card-text class="pt-2">
          <div v-if="item.started" class="caption">
            Start: {{ new Date(item.started * 1000).toLocaleString('de-De') }}
          </div>
          <div v-if="item.stopped" class="caption">
            Stop: {{ new Date(item.stopped * 1000).toLocaleString('de-De') }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            icon
            @click="startItem(item)"
            :disabled="giveaways.filter(g => g.started !== null && g.stopped === null).length > 0"
            color="success"
          >
            <v-icon>mdi-play</v-icon>
          </v-btn>
          <v-btn
            icon
            @click="stopItem(item)"
            :disabled="item.started === null || item.stopped !== null"
            color="error"
          >
            <v-icon>mdi-stop</v-icon>
          </v-btn>
          <v-btn
            icon
            :to="`/giveawayNoPointsEntrant/${item.id}`"
            target="_blank"
            :disabled="item.started === null"
            color="warning"
          >
            <v-icon>mdi-link</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn icon @click="copyItem(item)">
            <v-icon color="info">mdi-content-copy</v-icon>
          </v-btn>
          <v-btn icon @click="editItem(item)">
            <v-icon color="success">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            icon
            @click="deleteItem(item)"
            :disabled="item.started !== null && item.stopped === null"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-alert v-if="mobileItems.length === 0" type="info" class="mt-2">
        Keine Giveaways gefunden.
      </v-alert>

      <!-- Mobile Delete Dialog -->
      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">Sicher dieses Giveaway löschen?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDelete">Nein!</v-btn>
            <v-btn color="blue darken-1" text @click="deleteItemConfirm">Ja!</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Mobile Winner Dialog -->
      <v-dialog v-model="dialogWinner" max-width="500px">
        <v-card class="text-center">
          <v-card-title class="text-h5">
            Der Gewinner dieses Giveaways ist:<br>{{ winner }}
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="pickWinner(safeWinnerItem)">Reroll!</v-btn>
            <v-btn color="blue darken-1" text @click="closeGiveawayWinnerDialog">Verstanden!</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Mobile Edit Dialog (fullscreen) -->
      <v-dialog v-model="dialog" fullscreen>
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="close">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Giveaway bearbeiten</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn text @click="save" :loading="saving">Speichern</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container class="pa-4">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.title"
                    label="Titel"
                    :rules="[v => !!v || 'Titel is required']"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-checkbox v-model="editedItem.confirm_buyin" label="Kauf bestätigung" />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card>
      </v-dialog>
    </template>

    <v-btn color="success" class="mr-4 mt-3" @click="newGiveaway">
      neues Giveaway
    </v-btn>
  </v-container>
</template>

<script>

import BackendService from '@/services/BackendService';

export default {
  name: 'giveawayNoPointsList',

  data: () => ({
    safeWinnerItem: {},
    winner: '',
    search: '',
    dialog: false,
    dialogDelete: false,
    dialogWinner: false,
    saving: false,
    giveaways: [],
    valid: true,
    headers: [
      { text: 'Titel', value: 'title', align: 'center' },
      { text: 'Bestätigen', value: 'confirm_buyin', align: 'center' },
      { text: 'Start', value: 'started', align: 'center' },
      {
        text: 'Stop', value: 'stopped', align: 'center', sortable: false,
      },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    editedIndex: -1,
    editedItem: {
    },
    defaultItem: {
    },
  }),
  components: {
  },
  mounted() {
    BackendService.loadGiveawaysNoPoints().then((data) => {
      this.giveaways = data.data;
    });
  },
  computed: {
    mobileItems() {
      if (!this.search) return this.giveaways;
      const s = this.search.toLowerCase();
      return this.giveaways.filter((g) => g.title && g.title.toLowerCase().includes(s));
    },
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.giveaways.indexOf(item);
      this.editedItem = { ...item };
      this.dialog = true;
    },
    copyItem(item) {
      this.editedItem = { ...item };
      delete this.editedItem.id;
      this.dialog = true;
    },
    newGiveaway() {
      this.editedIndex = -1;
      this.editedItem = { };
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },
    deleteItemConfirm() {
      BackendService.deleteGiveawayNoPoints({
        id: this.editedItem.id,
      }).then((data) => {
        this.giveaways = data.data;
        this.closeDelete();
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },
    deleteItem(item) {
      this.editedIndex = this.giveaways.indexOf(item);
      this.editedItem = { ...item };
      this.dialogDelete = true;
    },
    startItem(item) {
      BackendService.startGiveawayNoPoints({
        id: item.id,
        title: item.title,
      }).then((data) => {
        this.giveaways = data.data;
      });
    },
    stopItem(item) {
      BackendService.stopGiveawayNoPoints({
        id: item.id,
        title: item.title,
      }).then((data) => {
        this.giveaways = data.data;
      });
    },
    closeGiveawayWinnerDialog() {
      this.dialogWinner = false;
    },
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        BackendService.saveGiveawayNoPoints(
          this.editedItem,
        ).then((data) => {
          this.giveaways = data.data;
        }).catch(() => {
          alert('nö!');
        }).finally(() => {
          this.saving = false;
          this.close();
        });
      }
    },
  },
};
</script>
